import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { CustomerManagementList } from '@/components/pages/Admin/CustomerManagement/List'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/customer')({
  component: CustomerPage,
})

function CustomerPage() {
  const t = useTranslations('admin.customer_management')

  return (
    <HomeContentContainer title={t('title')}>
      <CustomerManagementList />
    </HomeContentContainer>
  )
}

